<template>
  <div
    :class="{ 'bg-white': !nightMode, 'bg-dark': nightMode }"
    class="pt-5 p-st"
  >
    <div
      class="container"
      data-aos="fade"
      data-aos-once="true"
      data-aos-duration="1000"
    >
      <div class="row align-items-center">
        <div class="col-xl-6 col-bg-6 col-md-6 col-sm-12 text-center">
          <img style="width: 450px" :src="picture" />
        </div>
        <div class="col-xl-6 col-bg-6 col-md-6 col-sm-12 pt-5">
          <span
            class="home-title"
            :class="{ pgray: !nightMode, 'text-light': nightMode }"
          >
            Hi, I am Bongomin Daniel!
          </span>
          <div>
            <hr />
            <p></p>
            <p v-html="description"></p>
          </div>
          <div class="text-center pb-4">
            <div class="buttons">
              <a class="twitter" @click="open('github')"
              v-tooltip.bottom="'GitHub'">
              <i class="fab fa-linkedin"></i>
              </a>
              <a class="github" @click="open('github')"
              v-tooltip.bottom="'Github'"><i class="fab fa-github"></i></a>
              <a class="resume" @click="open('resume')"
              v-tooltip.bottom="'Resume'"><i class="fa fa-file"></i></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import info from "../../info";

import Wave from "./helpers/Wave";

export default {
  name: "Home",
  components: {
    Wave,
  },
  props: {
    nightMode: {
      type: Boolean,
    },
  },
  data() {
    return {
      picture: info.flat_picture,
      description: info.description,
      name: info.name,
      linkedin: info.links.linkedin,
      github: info.links.github,
      behance: info.links.behance,
      resume: info.links.resume,
    };
  },
  methods: {
    open(link) {
      switch (link) {
        case "linkedin":
          window.open(this.linkedin, "_blank");
          break;
        case "github":
          window.open(this.github, "_blank");
          break;
        case "behance":
          window.open(this.behance, "_blank");
          break;
        case "resume":
          window.open(this.resume, "_blank");
          break;
      }
    },
  },
};
</script>

<style scoped>
.home-title {
  font-size: 32px;
  font-weight: 500;
  line-height: 1.2;
  margin-bottom: 1rem;
  letter-spacing: -0.5px;
  text-align: left;
}

/* Web title improvements */
@media only screen and (min-width: 769px) {
  .home-title {
    font-size: 32px;
    text-align: left;
    letter-spacing: -0.3px;
  }
}

/* Mobile responsive typography */
@media only screen and (max-width: 768px) {
  .home-title {
    font-size: 28px;
    text-align: center;
    letter-spacing: -0.2px;
    margin-bottom: 1.2rem;
  }
}

@media only screen and (max-width: 480px) {
  .home-title {
    font-size: 24px;
    text-align: center;
    letter-spacing: -0.1px;
    margin-bottom: 1rem;
  }
}

img {
  max-width: 800px;
  max-height: 500px;
  margin-top: 80px;
  transform: rotateY(180deg);
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

img:hover {
  transform: rotateY(180deg) scale(1.05);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
}

/* Medium screens */
@media only screen and (max-width: 992px) {
  img {
    max-width: 350px;
    max-height: 350px;
    margin-top: 40px;
  }
}

/* Small screens and mobile */
@media only screen and (max-width: 768px) {
  img {
    width: 250px !important;
    height: 250px !important;
    max-width: 250px !important;
    max-height: 250px !important;
    object-fit: cover;
    border-radius: 50%;
    margin-top: 40px;
    margin-bottom: 20px;
    border: 3px solid #759cc9;
    box-shadow: 0 8px 25px rgba(117, 156, 201, 0.3);
    aspect-ratio: 1/1;
  }
}

/* Extra small mobile devices */
@media only screen and (max-width: 480px) {
  img {
    width: 200px !important;
    height: 200px !important;
    max-width: 200px !important;
    max-height: 200px !important;
    margin-top: 30px;
    margin-bottom: 20px;
  }
}

.fa {
  font-size: 15px;
}

.btn {
  border-color: #759cc9;
  color: #759cc9;
}

.btn:hover {
  background-color: #759cc9;
  border-color: #759cc9;
  color: white;
}

.btn:focus {
  background-color: #759cc9;
  border-color: #759cc9;
  color: white;
}

.btn:focus {
  outline: none !important;
}

p {
  text-align: justify;
  font-weight: 400;
  line-height: 1.6;
  margin-bottom: 1rem;
  letter-spacing: 0.3px;
}

/* Web text improvements */
@media only screen and (min-width: 769px) {
  p {
    text-align: justify;
    font-size: 16px;
    line-height: 1.7;
    letter-spacing: 0.2px;
  }
}

/* Mobile responsive text */
@media only screen and (max-width: 768px) {
  p {
    text-align: left;
    font-size: 16px;
    line-height: 1.6;
    letter-spacing: 0.1px;
    margin-bottom: 0.8rem;
  }
}

/* Small mobile devices */
@media only screen and (max-width: 480px) {
  p {
    text-align: left;
    font-size: 15px;
    line-height: 1.5;
    letter-spacing: 0.1px;
    margin-bottom: 0.7rem;
  }
}

.buttons {
  margin-top: 40px;
}
.buttons a {
  margin-right: 30px;
  width: 64px;
  height: 64px;
  font-size: 24px;
  display: inline-block;
  position: relative;
  line-height: 64px;
  background-color: #eaeaea;
  background-image: linear-gradient(to bottom, #f6f6f6, #eaeaea);
  border-radius: 32px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.25), 0 2px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

/* Mobile responsive buttons */
@media only screen and (max-width: 768px) {
  .buttons {
    margin-top: 30px;
  }
  .buttons a {
    margin-right: 20px;
    width: 56px;
    height: 56px;
    font-size: 20px;
    line-height: 56px;
    border-radius: 28px;
  }
}

@media only screen and (max-width: 480px) {
  .buttons {
    margin-top: 25px;
  }
  .buttons a {
    margin-right: 15px;
    width: 50px;
    height: 50px;
    font-size: 18px;
    line-height: 50px;
    border-radius: 25px;
  }
}
.buttons a:active {
  top: 1px;
  background-image: linear-gradient(to bottom, #eaeaea, #f6f6f6);
}
.buttons a:active::before {
  top: -9px;
}
.buttons a::before {
  content: "";
  position: absolute;
  z-index: -1;
  top: -8px;
  right: -8px;
  bottom: -8px;
  left: -8px;
  background-color: #eaeaea;
  border-radius: 140px;
  opacity: 0.5;
}
:hover .buttons a::before {
  opacity: 1;
}

.twitter:hover::before {
  background-color: #c6f0f8;
}

.github:hover::before {
  background-color: #dae1f0;
}

.resume:hover::before {
  background-color: #fadae6;
}
/* LEAVES */
</style>
